/**
 * Portal Manta · EstruturaTab
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V } from '../../globals.js';
import { THl, TDl } from '../../app-globals.js';

function EstruturaTab({lote}){
  const eo=lote.dados_manta?.estrutura_orcamento||{};
  const classes=eo.classes||[];
  if(!classes.length) return <div style={{padding:24,color:V.g4,fontSize:11}}>Sem dados de estrutura</div>;
  return(<div style={{padding:'12px 16px'}}>
    <div style={{fontSize:12.5,fontWeight:700,color:V.br2,marginBottom:14}}>Estrutura do Orçamento</div>
    {classes.map((cls,ci)=>(
      <div key={ci} style={{marginBottom:18}}>
        <div style={{fontSize:11,fontWeight:700,color:V.br,background:V.g1,padding:'6px 12px',borderRadius:'8px 8px 0 0',border:`1px solid ${V.g2}`}}>{cls.classe}</div>
        <div style={{border:`1px solid ${V.g2}`,borderTop:'none',borderRadius:'0 0 8px 8px',overflow:'hidden'}}>
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead><tr>
              <th style={{...THl,width:'30%',background:'#fff',borderBottom:`1px solid ${V.g2}`}}>Descrição</th>
              <th style={{...THl,background:'#fff',borderBottom:`1px solid ${V.g2}`}}>Abrangência</th>
            </tr></thead>
            <tbody>{cls.itens.map((it,ii)=>(<tr key={ii} style={{borderBottom:`1px solid ${V.g1}`,background:ii%2===0?'#fff':V.g0}}>
              <td style={{...TDl,padding:'7px 10px',fontSize:11,color:V.br2,fontWeight:600}}>{it.descricao}</td>
              <td style={{...TDl,padding:'7px 10px',fontSize:10.5,color:V.g7,whiteSpace:'normal',lineHeight:1.5}}>{it.abrangencia}</td>
            </tr>))}</tbody>
          </table>
        </div>
      </div>
    ))}
  </div>);}

export { EstruturaTab };
export default EstruturaTab;
